import React from 'react'
import styled from 'styled-components'

const FeatureCard = ({ title, text }) => {
    return (
        <Card>
            <span className='title'>{title}</span>
            <span className='text'>{text}</span>
        </Card>
    )
}

export default FeatureCard

const Card = styled.div`
display: flex;
width: 30%;
flex-direction: column;
gap: 1rem;
align-items: center;
color: var(--color);



.title {
    font-size: 2.25rem;
    font-weight: 600;
    color: var(--color);
}

.text {
    font-size: 1.7rem;
    font-weight: 400;
    text-align: start;
    color: var(--color);
}


`